import { formatAmount } from '@mlm/shared';
import type { ActiveSlot } from '../../lib/api';
import { useCoinLabel } from '../../lib/use-coin-label';

/**
 * The selected slot's spendable balances, so the cashier can see BEFORE ringing
 * up whether the buyer can cover a scrip tender. Display only — the server
 * re-checks under a lock at checkout, and this figure is materialized (so a
 * commission earned seconds ago may not be in it yet).
 */
export function SlotBalances({
  slot,
  showGc,
  showCoin,
}: {
  slot: ActiveSlot | null;
  showGc: boolean;
  showCoin: boolean;
}) {
  const coinLabel = useCoinLabel();
  if (!slot) return null;
  // A tender the tenant doesn't accept is noise — unless the member is holding
  // some, in which case hiding it would be the confusing half.
  const gc = showGc || slot.availableGc !== '0.0000';
  const coin = showCoin || slot.availableCoin !== '0.0000';
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5 pt-1 text-xs text-muted-foreground">
      <span>
        Cash <span className="font-medium text-foreground">₱{formatAmount(slot.available)}</span>
      </span>
      {gc && (
        <span>
          GC <span className="font-medium text-foreground">{formatAmount(slot.availableGc)}</span>
        </span>
      )}
      {coin && (
        <span>
          {coinLabel}{' '}
          <span className="font-medium text-foreground">{formatAmount(slot.availableCoin)}</span>
        </span>
      )}
    </div>
  );
}
